import * as autoBind from "auto-bind";
import * as React from "react";
import LoadObject from "../../../load_objects/LoadObject";
import { ILogin } from "../../../login/records/Login";
import { IRevokeTokenViewProps, RevokeTokenView } from "./RevokeTokenView";
import "./token.css";

interface IProps
{
    loginLoader: LoadObject<ILogin>;
    revokeToken(username, password);
}

interface IState
{
    showRevokeTokenView: boolean;
    showRevokeTokenSuccess: boolean;
}

export default class TokenView extends React.Component<IProps, IState> {

    constructor(props: any)
    {
        super(props);
        autoBind.react(this);

        this.state = {
            showRevokeTokenView: false,
            showRevokeTokenSuccess: false
        };
    }

    public render()
    {
        let token = "";

        const loginLoader = this.props.loginLoader;
        if (loginLoader)
        {
            if (!loginLoader.isLoading() && loginLoader.hasValue())
            {
                token = loginLoader.getValueEnforcing().token || "";
            }
        }

        const showRevokeTokenSuccess = this.state.showRevokeTokenSuccess
            ? ""
            : "hidden";

        return (
            <div>
                <button className="newTokenButton" onClick={this.onRevokeTokenClick}>Create new token</button>

                <p className={"newTokenSuccessMessage " + showRevokeTokenSuccess}>Success! Your new token is shown in the box above</p>

                <RevokeTokenView
                    show={this.state.showRevokeTokenView}
                    onClose={this.onRevokeTokenViewClose}
                    revokeToken={this.revokeToken}
                    loginLoader={this.props.loginLoader} />
            </div>
        );
    }

    public componentWillReceiveProps(newProps: IProps)
    {
        if (this.props.loginLoader.hasValue() && newProps.loginLoader.hasValue()
            && this.props.loginLoader.getValueEnforcing().token !== newProps.loginLoader.getValueEnforcing().token)
        {
            const newState = {
                showRevokeTokenView: this.state.showRevokeTokenView,
                showRevokeTokenSuccess: true
            };

            this.setState(newState);
        }
        else
        {
            const newState = {
                showRevokeTokenView: this.state.showRevokeTokenView,
                showRevokeTokenSuccess: false
            };

            this.setState(newState);
        }
    }

    private onRevokeTokenClick()
    {
        const newState = {
            showRevokeTokenView: true
        };

        this.setState(newState);
    }

    private onRevokeTokenViewClose()
    {
        const newState = {
            showRevokeTokenView: false
        };

        this.setState(newState);
    }

    private revokeToken(password)
    {
        let username;
        const loginLoader = this.props.loginLoader;
        if (loginLoader &&
            !loginLoader.isLoading() &&
            loginLoader.hasValue())
        {
            username = loginLoader.getValue()!.username;
        }
        else
        {
            throw new Error("Tried to revoke token while not logged in");
        }

        this.props.revokeToken(username, password);
    }

    private onTokenClick(evt)
    {
        evt.target.focus();
        evt.target.select();
    }
}
